import { SearchParams, SearchParamsConfig } from "../../../types/search-types";
import { Plugin } from "..";

class PriceRange implements Plugin {
  async exec(
    segment: string,
    searchParams: SearchParams,
    _config: SearchParamsConfig,
  ): Promise<SearchParams> {
    if (searchParams.priceMin || searchParams.priceMax) {
      return searchParams;
    }

    const minRegex = /over-([1-9]\d{0,4})/;
    const maxRegex = /under-([1-9]\d{0,4})/;
    const rangeRegex = /([1-9]\d{0,4})-to-([1-9]\d{0,4})/;

    const minMatch = minRegex.exec(segment);

    if (minMatch) {
      searchParams.priceMin = parseInt(minMatch[1]);
    } else {
      const maxMatch = maxRegex.exec(segment);

      if (maxMatch) {
        searchParams.priceMax = parseInt(maxMatch[1]);
      } else {
        const rangeMatch = rangeRegex.exec(segment);

        if (rangeMatch) {
          searchParams.priceMin = parseInt(rangeMatch[1]);
          searchParams.priceMax = parseInt(rangeMatch[2]);
        }
      }
    }

    return searchParams;
  }
}

export const priceRange = new PriceRange();
